<template>
  <div class="pb-20" v-if="dynamicSchedules && dynamicSchedules.length && studyDetails && dynamicSchedulingService">
    <div class="fw-500 fs-20">
      Dynamic Scheduling
    </div>
    <div class="saved-scheduling-details">
      <div class="card inner-card" v-for="(dynamicSchedule, index) in dynamicSchedules" :key="'schedule-' + index">
        <div class="row">
          <div class="col-md-12 p-0">
            <div class="activity-info-col">
              <div v-for="(condition, c_index) in dynamicSchedule.conditions" :key="'condition-' + c_index">
                <div class="row">
                  <div class="col-md-3 pl-12">
                    <div class="Activity_Title" v-if="condition.isPrimaryCondition">
                      Event Trigger
                    </div>
                    <div class="Activity_Title" v-else>
                      Additional Condition
                    </div>
                    <span class="activity-value" v-if="dynamicSchedulingService.triggers[condition.trigger]">{{ dynamicSchedulingService.triggers[condition.trigger].text }}</span>
                  </div>

                  <div class="col-md-3 pl-12" v-if="dynamicSchedulingService.isStepInActivityCompleted(condition.trigger)">
                    <div class="Activity_Title">Activity Step</div>
                    <span class="activity-value">{{ dynamicSchedulingService.getStepInActivityStepTitle(condition) }}</span>
                  </div>

                  <div class="col-md-3 pl-12" v-if="dynamicSchedulingService.isStepInActivityCompleted(condition.trigger)">
                    <div class="Activity_Title">Response</div>
                    <span class="activity-value">{{ dynamicSchedulingService.changeDropdownValuesBasedOnResponseType(condition) }}</span>
                  </div>

                  <!-- For Participants Information -->
                  <div class="col-md-9 pl-12" v-if="dynamicSchedulingService.isParticipant(condition.trigger)">
                    <div class="row">
                      <div class="col-md-4 pl-0">
                        <div class="Activity_Title">Field</div>
                        <span class="activity-value">{{ dynamicSchedulingService.triggers.Participant.field[condition.field] }}</span>
                      </div>
                      <div class="col-md-4" v-if="condition.operator">
                        <div class="Activity_Title">Operator</div>
                        <span class="activity-value">{{ dynamicSchedulingService.triggers.Participant.operator[condition.operator] }}</span>
                      </div>
                      <div class="col-md-4">
                        <div class="Activity_Title">
                          {{ dynamicSchedulingService.triggers.Participant.field[condition.field] }}
                        </div>
                        <span class="activity-value" v-if="condition.field === 'gender' && dynamicSchedulingService.registrationConfigDetails">{{ dynamicSchedulingService.getGenderText(condition.value) }}</span>
                        <span class="activity-value" v-else-if="condition.field === 'language'">{{ dynamicSchedulingService.getLanguageName(condition.value) }}</span>
                        <span class="activity-value" v-else-if="isDateOfBirth(condition.field)">{{ dynamicSchedulingService.getReadableDOB(condition.value) }}</span>
                        <span class="activity-value" v-else-if="condition.field === 'country'">{{ dynamicSchedulingService.getCountryName(condition.value) }}</span>
                        <span class="activity-value" v-else-if="condition.field === 'ageRange' && dynamicSchedulingService.registrationConfigDetails">{{ dynamicSchedulingService.getAgeRangeText(condition.value) }}</span>
                        <span class="activity-value" v-else>{{ condition.value }}</span>
                      </div>
                    </div>
                  </div>

                  <!-- Milestones completed -->
                  <div class="col-md-3 pl-12" v-if="dynamicSchedulingService.isMilestoneComplete(condition.trigger)">
                    <div class="Activity_Title">Milestones</div>
                    <span class="activity-value">{{ dynamicSchedulingService.getMilestones(condition.milestones) }}</span>
                  </div>
                </div>
                <hr />
              </div>

              <!-- row3 -->
              <div v-for="(action, a_index) in dynamicSchedule.actions" :key="'action-' + a_index">
                <div class="row">
                  <div class="col-md-3 pl-12">
                    <div class="Activity_Title">Action</div>
                    <span class="activity-value" v-if="dynamicSchedulingService.actions[action.type]">{{ dynamicSchedulingService.actions[action.type].text }}</span>
                  </div>
                  <div class="col-md-3 pl-12" v-if="dynamicSchedulingService.forActionIsAddAnActivity(action.type) || dynamicSchedulingService.forActionIsRemovedAnActivity(action.type)">
                    <div class="Activity_Title">Activity</div>
                    <span class="activity-value">{{ dynamicSchedulingService.getActivityForSchedulings(action) }}</span>
                  </div>
                  <div class="col-md-3 pl-12" v-if="dynamicSchedulingService.forActionIsNotifySiteTeam(action.type)">
                    <div class="Activity_Title">Roles</div>
                    <span class="activity-value" v-if="action.role && (action.role.studyTeam || action.role.siteTeam)">{{ dynamicSchedulingService.getSiteTeamMemberNames(action.role) }}</span>
                  </div>
                </div>
                <hr />
              </div>

              <!-- Scheduling Details Starts -->
              <div v-for="(schedule, s_index) in dynamicSchedule.scheduling" :key="'schedule-' + s_index">
                <div class="row">
                  <div class="col-md-3 pl-12">
                    <div class="Activity_Title">Scheduling</div>
                    <span class="activity-value" v-if="dynamicSchedulingService.schedulings[schedule.type]">{{ dynamicSchedulingService.schedulings[schedule.type].text }}</span>
                  </div>
                  <div class="col-md-3 pl-12" v-if="schedule.type === 'milestone'">
                    <div class="Activity_Title">Milestones</div>
                    <span class="activity-value">{{ dynamicSchedulingService.getMilestonesForSchedulings(schedule) }}</span>
                  </div>
                  <div class="col-md-3 pl-12" v-else-if="schedule.type === 'custom'">
                    <div class="Activity_Title">Frequency</div>
                    <span class="activity-value">{{ schedule.frequency.title }}</span>
                  </div>
                  <div class="col-md-2 pl-12" v-else-if="schedule.type === 'noOfDays'">
                    <div class="Activity_Title">In Number of Days</div>
                    <span class="activity-value">{{ schedule.days }}</span>
                  </div>
                </div>
              </div>
              <!-- Scheduling Details Ends -->
              <hr />
              <div class="row">
                <div class="col-md-3 offset-md-9 d-flex justify-content-end">
                  <button type="button" class="btn del-link-btn" @click="deleteDynamicSchedule(index)">
                    Delete
                  </button>
                  <button type="button" class="btn btn-outline-primary ml-10 edit-btn" @click="editSelectedDynamicSchedule(dynamicSchedule, index)">
                    Edit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import swal from "sweetalert2";
import { cloneDeep } from "lodash";

export default {
  name: "dynamic-scheduling-overview",
  data() {
    return {
      dynamicSchedules: [],
      studyDetails: {},
      dynamicSchedulingService: null
    };
  },
  props: {
    studyData: {
      type: Object,
      default: null,
      required: false
    }
  },
  computed: {
    ...mapGetters(["getDynamicActivitySchedules", "getDynamicSchedulingServiceData"])
  },
  watch: {
    getDynamicActivitySchedules: {
      deep: true,
      immediate: true,
      handler: function(newInfo) {
        this.dynamicSchedules = newInfo;
      }
    },
    studyData: {
      deep: true,
      immediate: true,
      handler: function(newInfo) {
        if (newInfo) {
          this.studyDetails = newInfo;
        }
      }
    },
    getDynamicSchedulingServiceData: {
      deep: true,
      immediate: true,
      handler: function(newData) {
        if (newData) {
          this.dynamicSchedulingService = newData;
        }
      }
    }
  },
  methods: {
    ...mapActions(["setDynamicActivitySchedules", "setDynamicActivityScheduleForEditing"]),
    editSelectedDynamicSchedule(dynamicSchedule, index) {
      this.$emit("edit-dynamic-schedule");
      const editData = {
        addOrEditMode: "edit",
        index: index,
        data: dynamicSchedule
      };
      this.setDynamicActivityScheduleForEditing(cloneDeep(editData));
    },
    deleteDynamicSchedule(index) {
      swal({
        title: "Are you sure you want to delete this dynamic event?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#f16559",
        confirmButtonText: "Cancel",
        cancelButtonText: "Delete"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.dynamicSchedules.splice(index, 1);
          this.setDynamicActivitySchedules([...this.dynamicSchedules]);
        }
      });
    },
    isDateOfBirth(key) {
      return key === "dob" || key === "birthDate" || key === "dobWithMonthYear" || key === "dobWithYear";
    }
  }
};
</script>

<style scoped lang="scss">
.saved-scheduling-details {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 450px;
  margin: 1rem 0 0;
}

.saved-scheduling-details::-webkit-scrollbar-thumb {
  background-color: #c4c4c4;
  border-radius: 4px;
  height: 50px;
  border: 3px solid transparent;
}

.saved-scheduling-details::-webkit-scrollbar-track {
  background: transparent;
}

.saved-scheduling-details::-webkit-scrollbar {
  width: 4px;
}
.inner-card {
  border: none;
  margin-bottom: 15px;
  padding: 10px 0 20px;
  border-radius: 4px !important;
  background-color: #f5f8fa;
  border: solid 1px #e2e7ea;
}

.inner-card:last-child {
  margin-bottom: 0 !important;
}
.activity-info {
  margin-top: 15px;
  font-size: 14px;
  color: #000000;
}

.Activity_Title {
  line-height: 2.5;
  font-size: 12px;
  font-weight: 500;
  color: #959fa4;
}
.activity-value {
  color: #000000;
  font-size: 12px;
  font-weight: 600;
}
.activity-info-col .col {
  padding-left: 7px;
}
.del-link-btn {
  padding: 0.05rem 0.75rem 0.2rem 0.75rem !important;
  color: #f16559;
  font-size: 15px;
  font-weight: normal;
  background: transparent;
  border: none;
  outline: none !important;
  box-shadow: none !important;
}
.edit-btn {
  color: #4c8ce4;
  font-size: 15px;
  font-weight: normal;
  padding: 2px 28px 3px 28px !important;
  border-radius: 4px;
  border: solid 1px #4c8ce4;
  background-color: #ffffff;
}
</style>
